// example:
//
// import dlog from '../utils/log'
//
// const ctx = "store.js";
// const ddlog = (msg) => { dlog(ctx,msg); }


const d = true;

function dlog(ctx,msg) {
    d && console.log(ctx+" | "+JSON.stringify(msg));
}

export default dlog;